import type { CollectionModelState } from '../collection.state';
import { CollectionModelCropParameterState } from './cropParameter.state';

export type ModelStateCropParameterTag = 'free';

export interface ModelStateCropParameter {
	id: string;
	tag: ModelStateCropParameterTag;
}

export class CollectionModelCropParameterMutator<
	T extends CollectionModelCropParameter = CollectionModelCropParameter,
> {
	cropParameter: T;

	constructor(cropParameter: T) {
		this.cropParameter = cropParameter;
	}

	setValue(state: T['state']) {
		this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, state);
	}

	/** Gives a shallow clone of the crop correction state */
	getValue(): T['state'] {
		return Object.assign({}, this.cropParameter.state);
	}

	/**
	 * Remove the state of this crop correction
	 * *Warning:* You will need to unlink & remove the crop correction from the list before destroying the state.
	 * @see CollectionModelCropParameterStateMutator.remove
	 */
	destroyState() {
		this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, null);
	}

	/**
	 * Remove the crop correction,
	 * This will unlink and destroy the crop correction and all associated values.
	 *
	 * @see CollectionModelCropParameterStateMutator.remove
	 */
	remove() {
		this.cropParameter.cropParameterState.Mutator.remove(this.cropParameter);
	}
}

export abstract class CollectionModelCropParameter<T extends ModelStateCropParameter = ModelStateCropParameter> {
	abstract tag: ModelStateCropParameterTag;
	/** Computed id of the crop correction */
	instanceId: string;
	id: string;
	captureId: string;
	cropParameterState: CollectionModelCropParameterState;

	Mutator: CollectionModelCropParameterMutator;

	constructor(state: CollectionModelCropParameterState, cropParameterId: string, captureId: string) {
		this.instanceId = CollectionModelCropParameterState.cropParameterId(captureId, cropParameterId);
		this.id = cropParameterId;
		this.captureId = captureId;
		this.cropParameterState = state;
	}

	get state(): T | null {
		return this.collectionState.getFieldValue(this.instanceId) as T;
	}

	get collectionState(): CollectionModelState {
		return this.cropParameterState.collection.state;
	}

	get isDeletable() {
		return true;
	}
}
